import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '..';
import type { SubmitButtonProps } from './SubmitButton';

export const ExecuteButton: FC<Omit<SubmitButtonProps, 'text'>> = ({
  onClick,
  loading,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      loading={loading}
      type="primary"
      htmlType="submit"
      onClick={onClick}
      disabled={disabled}
    >
      {t('execute')}
    </Button>
  );
};
